import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export type JoinBoardModalFragment = (
  { __typename: 'Board' }
  & Pick<Types.Board, 'id' | 'idOrganization' | 'name' | 'desc' | 'descData' | 'dateLastActivity'>
  & { cards: Array<(
    { __typename: 'Card' }
    & Pick<Types.Card, 'id'>
  )> }
);

export const JoinBoardModalFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'JoinBoardModal' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Board' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idOrganization' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'desc' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateLastActivity' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cards' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: { kind: 'EnumValue', value: 'visible' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseJoinBoardModalFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      JoinBoardModalFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseJoinBoardModalFragmentResult
  extends Omit<Apollo.UseFragmentResult<JoinBoardModalFragment>, 'data'> {
  data?: JoinBoardModalFragment;
}

export const useJoinBoardModalFragment = ({
  from,
  returnPartialData,
  ...options
}: UseJoinBoardModalFragmentOptions): UseJoinBoardModalFragmentResult => {
  const result = Apollo.useFragment<JoinBoardModalFragment>({
    ...options,
    fragment: JoinBoardModalFragmentDoc,
    fragmentName: 'JoinBoardModal',
    from: {
      __typename: 'Board',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as JoinBoardModalFragment };
};
